/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { TabMenu } from 'primereact/tabmenu';
import { SplitButton } from 'primereact/splitbutton';
import { Divider } from 'primereact/divider';
import { Timeline } from 'primereact/timeline';

import Iframe from '@components/Iframe';
import JustificationModal from '@components/JustificationModal';

import { generateLayoutsHtml } from '@actions/sections';
import { validatePermissionAction } from '@actions/sessionPermission';

import catalogPermissionsId from '@constants/catalogPermissionsId'
import { AuthorizedStatus } from '@constants/general'


import './style.scss'

class Preview extends Component {
  constructor(props) {
    super(props)
    this.state = {
      step: 0,
      currentLayoutHtml: '',
      isFirstRender: true,
      showModalJustification: {
        isVisible: false,
        title: '',
        description: '',
        label: '',
        continueAction: null,
      },
    }
    this.actions = [
      {
        label: this.props.t('Cancelar'),
        command: (e) => {}
      }
    ]
    // this.actionsEdit = [
    //   {
    //     label: this.props.t('Enviar a autorizar'),
    //     icon: 'pi pi-users',
    //     command: (e) => {
    //         this.props.authorize()
    //     }
    //   },
    //   // {
    //   //   label: this.props.t('Eliminar versión'),
    //   //   icon: 'pi pi-trash',
    //   //   command: (e) => {
    //   //       this.props.authorize()
    //   //   }
    //   // },
    //   {
    //       label: this.props.t('Autorizar'),
    //       icon: 'pi pi-check-circle',
    //       command: (e) => {
    //           this.props.authorize()
    //       }
    //   },
    // //   {
    // //       label: this.props.t('Rechazar'),
    // //       icon: 'pi pi-times',
    // //       command: (e) => {
    // //         this.props.reject()
    // //       }
    // //   },
    // //   {
    // //       label: this.props.t('Cancelar'),
    // //       command: (e) => {}
    // //   }
    // ]
  }

  async componentDidMount() {
    const { generateLayoutsHtml, itemsTabsLenguages, t, componentsAvailables, componentsSelected } = this.props
    if (componentsSelected.length) {
      await generateLayoutsHtml({
        componentsAvailables,
        componentsSelected
      })
      this.setLayoutByLanguagetab(0)
    }
    this.validateOptionsSlit()
  }

  validateOptionsSlit = () => {
    const { isEdit, validatePermissionAction, estatusSection } = this.props
    if (isEdit) {
      // @Editar seccion
      if (estatusSection !== AuthorizedStatus.STATUS_AUTHORIZED) {
        const canDeleteVersion = validatePermissionAction(catalogPermissionsId.ELIMINAR_SECCION)
        if (canDeleteVersion) {
          this.actions.unshift({
            label: this.props.t('Eliminar Version'),
            icon: 'pi pi-times',
            command: () => {
              this.props.deleteVersion()
            }
          })
        }
        const hasAuthorized = validatePermissionAction(catalogPermissionsId.AUTORIZAR_RECHAZAR_PUBLICACION_DE_SECCION)
        if (hasAuthorized) {
          if (estatusSection !== AuthorizedStatus.STATUS_REJECTED) {
            this.actions.unshift({
              label: this.props.t('Rechazar'),
              icon: 'pi pi-exclamation-triangle',
              command: () => {
                this.props.reject()
              }
            })
          }
          this.actions.unshift({
            label: this.props.t('Autorizar'),
            icon: 'pi pi-check-circle',
            command: () => {
              this.saveSection(this.props.authorize)
            }
          })
        } else {
          if (estatusSection !== AuthorizedStatus.STATUS_PENDING) {
            this.actions.unshift({
              label: this.props.t('Enviar a autorizar'),
              icon: 'pi pi-envelope',
              command: () => {
                this.saveSection(this.props.sendAuthorize)
              }
            })
          }
        }
      }
    } else {
      // @Nueva seccion
      const hasAuthorized = validatePermissionAction(catalogPermissionsId.AUTORIZAR_RECHAZAR_PUBLICACION_DE_SECCION)
      if (hasAuthorized) {
        this.actions.unshift({
          label: this.props.t('Autorizar'),
          icon: 'pi pi-check-circle',
          command: () => {
            this.saveSection(this.props.authorize)
          }
        })
      } else {
        this.actions.unshift({
          label: this.props.t('Enviar a autorizar'),
          icon: 'pi pi-envelope',
          command: () => {
            this.saveSection(this.props.sendAuthorize)
          }
        })
      }
    }
  }


  onChangeTabLanguage = (index) => {
    this.setState({ step: index })
    this.setLayoutByLanguagetab(index)
  }

  setLayoutByLanguagetab = (index) => {
    const { keysLenguages, layoutsHtml } = this.props
    const { isFirstRender } = this.state
    const prefixLenguage = keysLenguages[index]
    const layout = layoutsHtml.find(item => item.language === prefixLenguage)
    const previewHtml = layout.previewHtml || layout.html
    this.setState({currentLayoutHtml: previewHtml})
    if (isFirstRender) {
      setTimeout(() => {
        this.setState({currentLayoutHtml: previewHtml, isFirstRender: false})
      }, 1000)
    }
  }

  saveSection = (action) => {
    const { t, componentsSelected } = this.props
    const isLanding = componentsSelected.length
    this.setState({
      showModalJustification: {
        isVisible: true,
        title: t('CONFIRMACIÓN'),
        description: t('¿Esta seguro que desea hacer este cambio?'),
        label: t('Justificación del cambio'),
        continueAction: ({justification}) => action(isLanding, justification),
      },
    });
  }

  render() {
    const { t, btnSubmitLoading, onBack, success, itemsStep, isEdit, componentsSelected  } = this.props;
    const { currentLayoutHtml, step, showModalJustification } = this.state

    const customizedMarker = ( index) => {
      if (index === step) return (<i className="pi pi-circle-on cursor-pointer" onClick={() => this.onChangeTabLanguage(index)} style={{ color: "#ffe357", fontSize: "1.4rem" }}/>)
      return (<i className="pi pi-circle-off cursor-pointer" onClick={() => this.onChangeTabLanguage(index)} style={{ color: "#bdc2ce", fontSize: "1.4rem" }}/>)
    };

    const contentTimeline = (item, index) => (<p className="cursor-pointer" onClick={() => this.onChangeTabLanguage(index)}>{item.label}</p>)

    return (
      <>
        <div className="p-grid p-justify-end">
          <div className="p-col-12 p-md-9 p-lg-9 footer-btn p-mb-4">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />
              {/* <Button
                label={t('Guardar')}
                type="button"
                className="p-button-primary"
                onClick={() => this.saveSection(this.props.success)}
                loading={btnSubmitLoading}
              /> */}
              <SplitButton label={t('Guardar')} icon="pi pi-save" onClick={() => this.saveSection(this.props.success)} model={this.actions}/>
            </div>
          </div>
        </div>
        { componentsSelected.length ? (
          <div className="p-fluid p-grid p-mb-4">
            <div className="p-col-12 p-md-3 p-lg-3">
              <Timeline value={itemsStep} align="right" marker={(item, index) => customizedMarker(index)} content={(item, index) => contentTimeline(item, index)} />
            </div>
            <Divider layout="vertical" />
            <div className="p-col">
                <div className="p-shadow-3 content-iframe">
                  <Iframe content={currentLayoutHtml.outerHTML} />
                </div>
            </div>
          </div>
          
        ) : (
          <div className="p-col-12  not-information">
                {t('Vista previa no disponible')}
            </div>
        )
        }
        <JustificationModal
          display={showModalJustification.isVisible}
          title={showModalJustification.title}
          description={showModalJustification.description}
          label={showModalJustification.label}
          onHidden={() => this.setState({showModalJustification: { isVisible: false }})}
          onContinueAction={showModalJustification.continueAction}
        />
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  layoutsHtml: state.section.layoutsHtml,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  itemsStep: state.catalogs.itemsLanguageCatalog,
  componentsAvailables: state.section.componentsAvailables,
  componentsSelected: state.section.componentsSelected,
  estatusSection: state.section.estatus
});

const mapDispatchToProps = {
  generateLayoutsHtml,
  validatePermissionAction
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Preview);

